import { Helmet } from 'react-helmet-async';
import { Header } from '../landing/components/Header';
import { PsychologistLandingBody } from './PsychologistLandingBody';

export function PsychologistLandingPage() {
	return (
		<>
			<Helmet>
				<title>
					Plumaa para psicólogos · Consultório digital com IA
				</title>
				<meta
					name="description"
					content="Agenda, prontuário com IA, videoconferência e WhatsApp. 7 dias grátis. A partir de R$ 89 no primeiro mês."
				/>
			</Helmet>
			<Header />
			<PsychologistLandingBody />
		</>
	);
}
